import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // Importieren Sie den Store, den Sie gerade erstellt haben
import "@/assets/global.css";
import "bootstrap/dist/css/bootstrap.css";
import "jquery";
import "bootstrap/dist/js/bootstrap.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faRobot,
  faLightbulb,
  faUsers,
  faClock,
  faBrain,
  faHandshakeAngle,
  faEuroSign,
  faHeart,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faFacebook,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

library.add(
  faRobot,
  faLightbulb,
  faUsers,
  faClock,
  faBrain,
  faHandshakeAngle,
  faEuroSign,
  faHeart,
  faInstagram,
  faFacebook,
  faLinkedin,
  faTrashCan
); // Add the icons you want to use

const app = createApp(App); // Create the Vue app
app.use(store); // Use the store

app.component("font-awesome-icon", FontAwesomeIcon); // Register the FontAwesomeIcon component globally
app.use(router); // Use the router

app.mount("#app"); // Mount the Vue app
